import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {reduxForm, reset, change} from 'redux-form';
import {hashHistory} from 'react-router';
import _ from 'lodash';
import {injectIntl} from "react-intl";

import {modifyPageLayoutComponents} from '../PageLayout';
import template from './AddNewEntity.rt';
import AddNewEntityHeader from './AddNewEntityHeader.rt';
import AddNewEntityFooter from './AddNewEntityFooter.rt';
import {
  getCustomerInfo, updateCustomerInfo, clearInitialValues, setHeaderText,
  showSavingProgress, _authGoogleCalendar, showSuccessPopup,
  handleFooterCancel, handleFooterSave, handleSetLogoFile, getSubscriptions, showESignatureOverlay,
  setSubscriptionId, loadPaymentGateways, savePaymentGateways, showFingerSignatureSetupOverlay, createFabricatorSubMidId
} from './AddNewEntityActions';
import {logout, showFabricatorsPopup} from '../../actions';
import {salesPersonPopupActions} from '../PageLayout/Popups/AssignSalesPersonPopup'
import {showAssignEntityPopup, errorBox_Show, messageBoxEx_Show} from '../../actions/A_Popups';
import {AccessRights} from './../../schemas/accessRightsModel';
import {isImageFile, bkgImage} from './../../utilities/helpers';
import {PARTS} from "../../schemas/accessRightsModel";
import misc from './../../misc';


const mapStateToProps = (state, ownProps) => {
  const {newaccount} = state;
  const {newEntity} = state.form;
  const {popups} = state;
  const formValues = newEntity ? newEntity.values : null;
  formValues && (formValues.billingAddress = formValues.billingAddress || {});

  let masterProfile = null;
  if (newaccount.assignedMasterProfile && newaccount.assignedMasterProfile.id) {
    masterProfile = newaccount.assignedMasterProfile;
  }
  if (!masterProfile && newaccount.customerInfo.masterProfile && newaccount.customerInfo.masterProfile.id) {
    masterProfile = newaccount.customerInfo.masterProfile;
  }
  masterProfile = masterProfile || {id: 0, isMaster: false};

  if (!newaccount.customerInfo.id) {
    newaccount.customerInfo.enabled = true;
  }

  const AR = AccessRights.get(state);

  const {clientType, clientSubType, entityId} = ownProps.location.query;
  let isSaveButtonVisible = true;
  if (clientType === 'Client') {
    isSaveButtonVisible = AR.v(PARTS.HUB_BUTTON_CUSTOMERS)
  }
  isSaveButtonVisible = isSaveButtonVisible && !newaccount.showESignatureOverlay;
  const rights = {
    isSaveButtonVisible
  }

  return {
    initialValues: newaccount.customerInfo,
    enableReinitialize: true, // http://redux-form.com/6.6.0/examples/initializeFromState/ p.1
    updateSuccess: newaccount.updateSuccess,
    headerText: newaccount.headerText,
    masterProfile,
    formValues,
    __error__: newaccount.__error__, // this comes from intercepting the JSON call, in case the back-end returns 400
    AR,
    rights,
    assignedEntities: newaccount.assignedEntities,
    subscriptions: newaccount.subscriptions,
    paymentProfile: newaccount.customerInfo.paymentProfile,
    kitchenSubscriptionId: misc.monads.NN(newaccount.customerInfo.kitchenSubscription, _ => _.id, 0),
    bathroomSubscriptionId: misc.monads.NN(newaccount.customerInfo.bathroomSubscription, _ => _.id, 0),
    showESignatureOverlay: newaccount.showESignatureOverlay,
    showFingerSignatureOverlay: newaccount.showFingerSignatureOverlay,
    homeAdvisorApiEndpointUrl: newaccount.homeAdvisorApiEndpointUrl
  };
};


const mapDispatchToProps = dispatch => ({
  getCustomerInfo: (customerId, clientType, clientSubType) => dispatch(getCustomerInfo(customerId, clientType, clientSubType)),
  getSubscriptions: () => dispatch(getSubscriptions()),
  setHeaderText: (headerText) => dispatch(setHeaderText(headerText)),
  updateCustomerInfo: (formData) => dispatch(updateCustomerInfo(formData)),
  clearInitialValues: () => dispatch(clearInitialValues()),
  logout: () => dispatch(logout()),
  authGoogleCalendar: (entityId) => dispatch(_authGoogleCalendar(entityId)),
  showProgress: () => dispatch(showSavingProgress()),
  showSuccessPopup: () => dispatch(showSuccessPopup()),
  showMasterProfileSelection: (assignedMasterProfile) => dispatch(showFabricatorsPopup(true, salesPersonPopupActions.setMasterProfile, (assignedMasterProfile ? assignedMasterProfile.id : 0))),
  showNoCallFabricatorSelection: (noCallFabricatorId, cb, type) => dispatch(showFabricatorsPopup(true, salesPersonPopupActions.chooseFabricator, {
    noCallFabricatorId,
    cb,
    type
  })),
  handleFooterCancel,
  handleFooterSave,
  showAssignEntityPopup: config => dispatch(showAssignEntityPopup(config)),
  errorBox_Show: config => dispatch(errorBox_Show(config)),
  handleSetLogoFile,
  messageBoxEx_Show: (show, type, title, message, buttons) => dispatch(messageBoxEx_Show(show, type, title, message, buttons)),
  showESignatureOverlayFn: show => dispatch(showESignatureOverlay(show)),
  setSubscriptionIdFn: (type, id) => dispatch(setSubscriptionId(type, id)),
  dispatch,
  loadPaymentGateways: (fabricatorId) => dispatch(loadPaymentGateways(fabricatorId)),
  savePaymentGateways: (model) => dispatch(savePaymentGateways(model)),
  createFabricatorSubMidId: (fabricatorId) => dispatch(createFabricatorSubMidId(fabricatorId)),
  showFingerSignatureOverlayAction: show => dispatch(showFingerSignatureSetupOverlay(show))
});

const getInfoByClientType = (clientType, clientSubType, id = null) => {
  let prefix = id ? 'EDIT ' : 'ADD NEW '
  switch (true) {
    case clientType === 'Fabricator' && !clientSubType:
      return {
        headerText: prefix + 'FABRICATOR',
        url: 'fabricators',
        entityType: 'fabricator'
      };
    case clientType === 'Fabricator' && clientSubType === 'Store':
      return {
        headerText: prefix + 'STORE',
        url: 'stores',
        entityType: 'store'
      };
    case clientType === 'Client' && !clientSubType:
      return {
        headerText: prefix + 'CUSTOMER',
        url: 'customers',
        entityType: 'customer'
      };
    case clientType === 'Customer':
      return {
        headerText: prefix + 'EMPLOYEE',
        url: 'employees',
        entityType: 'employee'
      };
    case clientType === 'User':
      return {
        headerText: prefix + 'USER',
        url: 'users'
      };
    default:
      return {
        headerText: prefix + 'CUSTOMER',
        url: 'users'
      };
  }
};

/*
 DashBoardEntity  |  ClientType  |  ClientSubType  |
 ---------------------------------------------------
 Fabricator       |  Fabricator  |  null           |
 Store            |  Fabricator  |  Store          |
 Employee         |  Customer    |  null           |
 Customer         |  Client      |  null           |
 */

class AddNewEntity extends Component {
  constructor(props) {
    super(props);

    if (this.props.showESignatureOverlay && !this.props.formValues)
      this.props.showESignatureOverlayFn(false);

    const {clientType, clientSubType, entityId} = this.props.location.query;
    const clientInfo = getInfoByClientType(clientType, clientSubType);

    //console.log(888, this.props.location.query);

    const isEmployee = clientType === 'Customer';
    const isCustomer = clientType === 'Client';
    const isFabricator = clientType === 'Fabricator' && !clientSubType;
    const isStore = clientType === 'Fabricator' && clientSubType === 'Store';
    let urlOnSave = clientInfo.url;
    const {AR} = this.props;
    if (AR.isClient())
      urlOnSave = '/';

    let canEditFields = true;
    let canEditPhone2 = true;
    let canChangePassword = false;
    let canEditCompanyName = false;
    let canEditPrimaryEmail = (AR.isSiteAdmin(false) || AR.isFabAdmin() || AR.isFabMaster());

    const canEditName = AR.isSiteAdmin(false) || !entityId || AR.v(PARTS.HUB_BUTTON_CUSTOMERS);

    if (!isFabricator && !isStore) {
      if (entityId) {
        canChangePassword = !AR.isClient();
      }
    }

    if (entityId) {
      if (clientType === 'Fabricator') {
        canEditFields = AR.isSiteAdmin(false) || AR.isFabMaster() || AR.v(PARTS.HUB_BUTTON_FABRICATORS);
        canEditCompanyName = AR.isSiteAdmin(false) || AR.isFabMaster() || AR.v(PARTS.HUB_BUTTON_FABRICATORS);
      } else if (clientType === 'Client') {
        canEditFields = !AR.isClient();
        canEditPhone2 = !AR.isClient() || AR.isMe(entityId, false);
        canEditCompanyName = !AR.isClient();
      }
    } else {
      switch (clientType) {
        case 'Client':
          canEditCompanyName = true;
          break;
        case 'Fabricator':
          canEditCompanyName = true;
          break;
      }
    }

    const canAddFabricator = AR.isSiteAdmin(false) || AR.isFabAdmin() || AR.isFabMaster();

    this.state = {
      bathroomPaymentType: "Select Program",
      bathroomProgramType: "Select",
      canAddFabricator,
      canChangePassword,
      canEditCompanyName,
      canEditFields,
      canEditName,
      canEditPhone2,
      canEditPrimaryEmail,
      ccCVV: '',
      ccExpMonth: '',
      ccExpYear: '',
      ccName: '',
      ccNum: '',
      ccTermsApproved: false,
      clientSubType: clientSubType || undefined,
      clientType: clientType || 'Client',
      defaultDepositDisclaimer: '',
      editDepositDisclaimer: '',
      entityId,
      entityType: isEmployee ? 'employee' : (isCustomer ? 'customer' : (isFabricator ? 'fabricator' : 'user')),
      fabricatorNeedToSignAgreement: false, //!entityId && isFabricator, // when creating a new fabricator an agreement must be signed
      initialBathroomPaymentType: "Select Program",
      initialBathroomProgramType: "Select",
      initialKitchenPaymentType: "Select Program",
      initialKitchenProgramType: "Select",
      isCustomer,
      isEmployee,
      isFabricator,
      isMasterFabricator: AR.isSiteAdmin(false) || AR.isFabMaster(),
      isNew: !entityId,
      isStore,
      kitchenPaymentType: "Select Program",
      kitchenProgramType: "Select",
      paymentGateway_MxMerchant_MerchantId: '',
      paymentGateway_MxMerchant_ApiKey: '',
      paymentGateway_MxMerchant_ApiSecret: '',
      paymentGateway_MxMerchant_NachaId: '',
      paymentGateway_MxMerchant_TestMode: false,
      paymentGateway_AuthNet_ApiLogin: '',
      paymentGateway_AuthNet_CustomEndpointUrl: '',
      paymentGateway_AuthNet_TestMode: false,
      paymentGateway_AuthNet_TransactionKey: '',
      saveCC: false,
      showAddCustomer: isFabricator,
      showAddStore: isFabricator,
      showChangePasswordPopup: false,
      showCreditCardOverlay: false,
      showDocuSignOverlay: false,
      showMasterProfileSelection: AR.isSiteAdmin() && !isCustomer && !isFabricator,
      showPaymentGateways: false,
      showPermissionsEmployeePopup: false,
      showPermissionsFabricatorPopup: false,
      showSendResetPasswordPopup: false,
      showingESignFor: null,
      urlOnSave,
      user: {},
      activeCurrency: "USD",
      activeCurrencyKitchen: "USD",
      activeWebHookDataType: "Json"
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.formValues) {
      if ((!this.state.ccName || !this.state.ccName.length) && nextProps.formValues.billingAddress && nextProps.formValues.billingAddress.name) {
        this.setState({ccName: nextProps.formValues.billingAddress.name});
      }
      if (!this.state.ccNum && nextProps.formValues.paymentProfile && nextProps.formValues.paymentProfile.paymentProfiles && nextProps.formValues.paymentProfile.paymentProfiles.length > 0) {
        this.setState({ccNum: nextProps.formValues.paymentProfile.paymentProfiles[0].payment.creditCard.cardNumber});
      }
      if (!this.state.defaultDepositDisclaimer && nextProps.formValues.disclaimer && nextProps.formValues.disclaimer !== this.state.defaultDepositDisclaimer) {
        this.setState({
          editDepositDisclaimer: nextProps.formValues.disclaimer || '',
          defaultDepositDisclaimer: nextProps.formValues.disclaimer || ''
        });
      }
      if (nextProps.formValues.currency && nextProps.formValues.currency !== this.state.activeCurrency) {
        this.setState({activeCurrency: nextProps.formValues.currency});
      }
      if (nextProps.formValues.currencyKitchen && nextProps.formValues.currencyKitchen !== this.state.activeCurrencyKitchen) {
        this.setState({activeCurrencyKitchen: nextProps.formValues.currencyKitchen});
      }
      if (nextProps.formValues.webHookProperties && nextProps.formValues.webHookProperties.dataType
        && nextProps.formValues.webHookProperties.dataType !== this.state.activeWebHookDataType) {
        this.setState({activeWebHookDataType: nextProps.formValues.webHookProperties.dataType});
      }

      if (nextProps.formValues.docuSignAuth && this.props.formValues && this.state.clientType === 'Fabricator'
        && !_.isEqual(this.props.formValues.docuSignAuth, nextProps.formValues.docuSignAuth)) {
        const obj = JSON.parse(nextProps.formValues.docuSignAuth);
        if (obj && (this.state.ds_sandBoxUserId !== obj.sandBoxClientId || this.props.formValues.enableDocuSign !== obj.isEnabled)) {
          this.setState({
            ds_sandBoxUserId: obj.sandBoxClientId,
            ds_sandBoxAuthToken: obj.accessToken,
            ds_prodClientId: obj.clientId,
            ds_prodUserId: obj.impersonateUserGuid,
            ds_prodPrivateKey: obj.privateKey,
            ds_isProduction: !obj.isSandBox,
            ds_checkOutContractId: (obj.docuSignTemplates && obj.docuSignTemplates.checkOutContract.id) || 0,
            docuSignObj: {...obj}
          });
          setTimeout(() => {
            this.props.dispatch(change('newEntity', 'enableDocuSign', obj.isEnabled));
          }, 500);
        }
      }
    }
    const bathroomSubscriptionId = nextProps.bathroomSubscriptionId;
    if (bathroomSubscriptionId > 0 && this.state.bathroomPaymentType && this.state.bathroomPaymentType.id !== bathroomSubscriptionId) {
      const bathroomSub = _.find(nextProps.subscriptions, s => s.id === bathroomSubscriptionId);
      if (bathroomSub) {
        const paymentTypes = this.getPaymentTypes("bathroom", bathroomSub.type, nextProps, bathroomSub.id);
        const paymentType = _.find(paymentTypes, pt => pt.id === bathroomSubscriptionId);
        this.setState({
          bathroomProgramType: bathroomSubscriptionId > 0 ? bathroomSub.type : "Select",
          bathroomPaymentType: bathroomSubscriptionId > 0 ? paymentType : "Select Program",
          initialBathroomProgramType: bathroomSubscriptionId > 0 ? bathroomSub.type : "Select",
          initialBathroomPaymentType: bathroomSubscriptionId > 0 ? paymentType : "Select Program"
        });
      }
    }
    const kitchenSubscriptionId = nextProps.kitchenSubscriptionId;
    if (kitchenSubscriptionId > 0 && this.state.kitchenPaymentType && this.state.kitchenPaymentType.id !== kitchenSubscriptionId) {
      const kitchenSub = _.find(nextProps.subscriptions, s => s.id === kitchenSubscriptionId);
      if (kitchenSub) {
        const paymentTypes = this.getPaymentTypes("kitchen", kitchenSub.type, nextProps, kitchenSub.id);
        const paymentType = _.find(paymentTypes, pt => pt.id === kitchenSubscriptionId);
        this.setState({
          kitchenProgramType: kitchenSubscriptionId > 0 ? kitchenSub.type : "Select",
          kitchenPaymentType: kitchenSubscriptionId > 0 ? paymentType : "Select Program",
          initialKitchenProgramType: kitchenSubscriptionId > 0 ? kitchenSub.type : "Select",
          initialKitchenPaymentType: kitchenSubscriptionId > 0 ? paymentType : "Select Program"
        });
      }
    }

    //console.log(444, bathroomSubscriptionId, kitchenSubscriptionId);
    if (nextProps.updateSuccess) {
      this.props.showSuccessPopup();
      if (!nextProps.__error__) {
        hashHistory.push(this.state.urlOnSave);
      }
    }
  }


  componentDidMount() {
    const {entityId, clientType, clientSubType} = this.props.location.query;
    if (entityId) {
      this.props.getCustomerInfo(entityId, clientType, clientSubType);

      this.props.loadPaymentGateways(entityId)
        .then((res) => {
            this.setState({
              paymentGateway_MxMerchant_MerchantId: (res && res.mxMerchant && res.mxMerchant.merchantId) || '',
              paymentGateway_MxMerchant_ApiKey: (res && res.mxMerchant && res.mxMerchant.apiKey) || '',
              paymentGateway_MxMerchant_ApiSecret: (res && res.mxMerchant && res.mxMerchant.apiSecret) || '',
              paymentGateway_MxMerchant_NachaId: (res && res.mxMerchant && res.mxMerchant.nachaId) || '',
              paymentGateway_MxMerchant_TestMode: (res && res.mxMerchant && res.mxMerchant.testMode) || '',
              paymentGateway_AuthNet_ApiLogin: (res && res.authorizeNet && res.authorizeNet.apiLoginId) || '',
              paymentGateway_AuthNet_TransactionKey: (res && res.authorizeNet && res.authorizeNet.transactionKey) || '',
              paymentGateway_AuthNet_TestMode: (res && res.authorizeNet && res.authorizeNet.testMode) || false,
              paymentGateway_AuthNet_customEndpointUrl: (res && res.authorizeNet && res.authorizeNet.customEndpointUrl) || '',
              paymentGateway_Cliq_FabricatorSubMid: (res && res.Cliq && res.Cliq.fabricatorSubMid) || '',
              paymentGateway_Cliq_DistributorSubMid: (res && res.Cliq && res.Cliq.distributorSubMid) || '',
              paymentGateway_Cliq_GatewayId: (res && res.Cliq && res.Cliq.gatewayId) || '',
              paymentGateway_Cliq_ServiceKey: (res && res.Cliq && res.Cliq.serviceKey) || ''
            })
          }
        );
    } else {
      this.props.getSubscriptions();
    }

    const {headerText} = getInfoByClientType(clientType, clientSubType, entityId);
    this.props.setHeaderText(headerText);

    document.addEventListener('cancel-esignature-overlay', () => {
      document.getElementsByClassName('new-account-content')[0].classList.remove('noscroll');
      switch (this.state.showingESignFor) {
        case 'kitchen':
          this.setState({
            kitchenPaymentType: this.state.initialKitchenPaymentType,
            kitchenProgramType: this.state.initialKitchenProgramType
          });
          break;
        case 'bathroom':
          this.setState({
            bathroomPaymentType: this.state.initialBathroomPaymentType,
            bathroomProgramType: this.state.initialBathroomProgramType
          });
          break;
      }
    });
  }


  componentWillUnmount() {
    this.props.clearInitialValues();
  }

  handleSetNoCallFabricator = (fabricator, set = true) => {
    if (set) {
      this.props.dispatch(change('newEntity', 'noCallFabricatorName', fabricator.name));
      this.props.dispatch(change('newEntity', 'noCallFabricatorId', fabricator.id));
    } else {
      if (!this.props.formValues.noCallFabricatorId) {
        // if no fabricator is selected and they click cancel, uncheck the Yes/No checkbox
        this.props.dispatch(change('newEntity', 'yesNoConsultationRequest', false));
      }
    }
  }

  handleShowPopup = (popupName) => {
    const {formValues} = this.props;
    const user = {
      id: formValues.id,
      name: `${formValues.firstName} ${formValues.lastName}`
    };

    const newState = {
      user
    };

    switch (popupName) {
      case "resetPassword":
        newState.showSendResetPasswordPopup = !this.state.showSendResetPasswordPopup;
        break;
      case "changePassword":
        newState.showChangePasswordPopup = !this.state.showChangePasswordPopup;
        break;
      case 'permissions':
        if (this.state.isEmployee || this.state.isCustomer) {
          newState.showPermissionsEmployeePopup = !this.state.showPermissionsEmployeePopup;
        } else if (this.state.isFabricator) {
          newState.showPermissionsFabricatorPopup = !this.state.showPermissionsFabricatorPopup;
        }
        break;
    }
    this.setState(newState);
  };

  handleShowPopupEx = (popupName) => {
    const {formValues, intl} = this.props;
    const user = {
      id: formValues.id,
      name: `${formValues.firstName} ${formValues.lastName}`
    };

    const headerText = this.state.isCustomer
      ? `${intl.formatMessage({id: "assignEntityPopup.addFabricatorToCustomer"})}: ${user.name}`
      : `${intl.formatMessage({id: "assignEntityPopup.addFabricatorsToFabricator"})}: ${user.name}`

    switch (popupName) {
      case "fabricators":
        this.props.showAssignEntityPopup({
          entityId: user.id,
          entityType: this.state.isCustomer ? 'customer' : 'fabricator',
          visible: true,
          entitiesType: 'fabricators',
          headerText,
          storePath: 'fabricators'
        });
        break;
      case "stores":
        this.props.showAssignEntityPopup({
          entityId: user.id,
          entityType: 'fabricator',
          visible: true,
          entitiesType: 'stores',
          headerText: 'Add Stores to fabricator: ' + user.name,
          storePath: 'stores'
        });
        break;
      default:
        throw `Unknown popup ${popupName}`;
    }

  }

  handleClosePopup = (popupName) => {
    const newState = {};
    switch (popupName) {
      case "permissions":
        newState.showPermissionsPopup = false;
        break;
      case "changePassword":
        newState.showChangePasswordPopup = false;
        break;
      case "resetPassword":
        newState.showSendResetPasswordPopup = false;
        break;
      case 'permissionsemployee':
        newState.showPermissionsEmployeePopup = false;
        break;
      case 'permissionsfabricator':
        newState.showPermissionsFabricatorPopup = false;
        break;
    }
    this.setState(newState);
  };

  handleSave = () => {
    if (this.state.fabricatorNeedToSignAgreement && this.props.subscriptions.length >= 1) {
      this.props.errorBox_Show({
        title: 'Error',
        text: 'Fabricator must sign the agreement.',
        rightButtonText: 'OK',
        isRightButtonVisible: true
      });
      return;
    }

    //console.log(666, this.state.kitchenProgramType, this.state.kitchenPaymentType);
    if (this.state.kitchenProgramType === 'enterprise' || this.state.kitchenProgramType === 'basics') {
      if (this.state.kitchenPaymentType.period !== 'monthly' && this.state.kitchenPaymentType.period !== 'annually') {
        this.props.errorBox_Show({
          title: 'Error',
          text: 'Kitchen visualizer program type enterprise or basics requires a payment type.',
          rightButtonText: 'OK',
          isRightButtonVisible: true
        });
        return;
      }
    }
    if (this.state.bathroomProgramType === 'enterprise' || this.state.bathroomProgramType === 'basics') {
      if (this.state.bathroomPaymentType.period !== 'monthly' && this.state.bathroomPaymentType.period !== 'annually') {
        this.props.errorBox_Show({
          title: 'Error',
          text: 'Bathroom visualizer program type enterprise or basics requires a payment type.',
          rightButtonText: 'OK',
          isRightButtonVisible: true
        });
        return;
      }
    }

    if (this.state.clientType === 'Customer') {

    }

    const logo = document.getElementById('logo');
    const file = logo ? logo.files[0] : null;
    const {formValues} = this.props;

    // console.log(888, formValues);

    let formData = new FormData();

    if (file) {
      formData.append('file', file);
    }

    if (formValues.enableDeposit) {
      if (/[^0-9\.]/g.test(formValues.deposit) || _.trim(formValues.deposit).length === 0) {
        this.props.messageBoxEx_Show(true, 'error', 'Deposit Error', 'Deposit must be a number only. i.e. for 10% enter 10, for 5.5% enter 5.5');
        return;
      }
    }

    if (this.state.clientType !== 'Customer') {
      if (this.state.clientType === 'Client') {
        let errors = [];
        if (_.trim(formValues.billingAddress.address1).length === 0) {
          errors.push('Address 1 is required.');
        }
        if (_.trim(formValues.billingAddress.city).length === 0) {
          errors.push('City is required.');
        }
        if (_.trim(formValues.billingAddress.state).length === 0) {
          errors.push('State is required.');
        }
        if (_.trim(formValues.billingAddress.zip).length === 0) {
          errors.push('5 digit zip code is required.');
        }
        if (errors.length > 0) {
          this.props.messageBoxEx_Show(true, 'error', 'Billing Information Errors', errors.join('<br />'));
          return;
        }
      }

      if (formValues.billingSameAsShipping) {
        formValues.shippingAddress = formValues.shippingAddress || {};
        formValues.shippingAddress.name = formValues.billingAddress.name;
        formValues.shippingAddress.address1 = formValues.billingAddress.address1;
        formValues.shippingAddress.address2 = formValues.billingAddress.address2;
        formValues.shippingAddress.city = formValues.billingAddress.city;
        formValues.shippingAddress.state = formValues.billingAddress.state;
        formValues.shippingAddress.zip = formValues.billingAddress.zip;
      }
    } else {
      formValues.billingAddress = null;
      formValues.shippingAddress = null;
    }

    if (formValues.redirectUrl && !_.startsWith(formValues.redirectURL.toLowerCase(), "http"))
      formValues.redirectURL = "http://" + formValues.redirectURL;

    formValues.clientType = this.state.clientType;
    if (this.state.clientSubType && this.state.clientSubType !== 'null') {
      formValues.clientSubType = this.state.clientSubType;
    }
    formValues.masterProfile = this.props.masterProfile;
    formValues.assignedEntities = {
      fabricators: this.props.assignedEntities.fabricators,
      stores: this.props.assignedEntities.stores
    };

    formValues.id = this.state.isNew ? 0 : this.state.entityId;

    formValues.bathroomSubscription = {id: misc.monads.NN(this.state.bathroomPaymentType, _ => _.id, 0)};
    formValues.kitchenSubscription = {id: misc.monads.NN(this.state.kitchenPaymentType, _ => _.id, 0)};

    if (this.state.saveCC) {
      formValues.ccName = this.state.ccName;
      formValues.ccNum = this.state.ccNum;
      formValues.ccExpMonth = this.state.ccExpMonth;
      formValues.ccExpYear = this.state.ccExpYear;
      formValues.ccCVV = this.state.ccCVV;

      if (!formValues.billingAddress || _.trim(formValues.billingAddress.address1 || '').length === 0
        || _.trim(formValues.billingAddress.state || '').length === 0
        || _.trim(formValues.billingAddress.zip || '').length === 0
      ) {
        this.props.errorBox_Show({
          title: 'Error',
          text: 'Billing Address is required when adding/updating credit card data.',
          rightButtonText: 'OK',
          isRightButtonVisible: true
        });
        return;
      }

    }

    const iClickLeadCount = parseInt(formValues.clickLeadCount);
    if (formValues.clickLeadCapture || formValues.clickLeadCaptureDashboard) {
      if (isNaN(iClickLeadCount) || iClickLeadCount < 1 || iClickLeadCount > 9999) {
        this.props.errorBox_Show({
          title: 'Error',
          text: 'Click Lead Count must be a number greater than 0 and less than 10,000',
          rightButtonText: 'OK',
          isRightButtonVisible: true
        });
        return;
      }
    } else if (isNaN(iClickLeadCount)) {
      formValues.clickLeadCount = 10; //if clickleadcount isn't a number, reset to default
    }

    const iClickLeadCountOnQuote = parseInt(formValues.clickLeadCountOnQuote);
    if (formValues.clickLeadCaptureOnQuote) {
      if (isNaN(iClickLeadCountOnQuote) || iClickLeadCountOnQuote < 1 || iClickLeadCountOnQuote > 9999) {
        this.props.errorBox_Show({
          title: 'Error',
          text: 'Click Lead Count On Quote must be a number greater than 0 and less than 10,000',
          rightButtonText: 'OK',
          isRightButtonVisible: true
        });
        return;
      }
    } else if (isNaN(iClickLeadCountOnQuote)) {
      formValues.clickLeadCountOnQuote = 10; //if clickleadcount isn't a number, reset to default
    }

    const iClickLeadCountKitchen = parseInt(formValues.clickLeadCountKitchen);
    if (formValues.clickLeadCaptureKitchen|| formValues.clickLeadCaptureDashboardKitchen) {
      if (isNaN(iClickLeadCountKitchen) || iClickLeadCountKitchen < 1 || iClickLeadCountKitchen > 9999) {
        this.props.errorBox_Show({
          title: 'Error',
          text: 'Click Lead Count must be a number greater than 0 and less than 10,000 - for Kitchen',
          rightButtonText: 'OK',
          isRightButtonVisible: true
        });
        return;
      }
    } else if (isNaN(iClickLeadCountKitchen)) {
      formValues.clickLeadCountKitchen = 10; //if clickleadcount isn't a number, reset to default
    }

    const iClickLeadCountOnQuoteKitchen = parseInt(formValues.clickLeadCountOnQuoteKitchen);
    if (formValues.clickLeadCaptureOnQuoteKitchen) {
      if (isNaN(iClickLeadCountOnQuoteKitchen) || iClickLeadCountOnQuoteKitchen < 1 || iClickLeadCountOnQuoteKitchen > 9999) {
        this.props.errorBox_Show({
          title: 'Error',
          text: 'Click Lead Count On Quote must be a number greater than 0 and less than 10,000 - for Kitchen',
          rightButtonText: 'OK',
          isRightButtonVisible: true
        });
        return;
      }
    } else if (isNaN(iClickLeadCountOnQuoteKitchen)) {
      formValues.clickLeadCountOnQuoteKitchen = 10; //if clickleadcount isn't a number, reset to default
    }

    const docuSignObj = this.state.docuSignObj || {};
    docuSignObj.isEnabled = this.props.formValues.enableDocuSign;
    formValues.docuSignAuth = JSON.stringify(docuSignObj);
    if (!formValues.webHookProperties || !formValues.webHookProperties.dataType) {
      if (!formValues.webHookProperties)
        formValues.webHookProperties = {};
      formValues.webHookProperties.dataType = this.state.activeWebHookDataType;
    }

    formData.append('json', JSON.stringify(formValues));
    this.props.showProgress();
    this.props.updateCustomerInfo(formData);
  };

  updateCheckBoxField = (input) => {
    switch (input.name) {
      case "enableQuote":
        !input.value && this.props.dispatch(change('newEntity', 'leadCapture', true));
        !input.value && this.props.dispatch(change('newEntity', 'twoFA', true));
        break;
      case "enableQuoteDashboard":
        !input.value && this.props.dispatch(change('newEntity', 'leadCaptureDashboard', true));
        !input.value && this.props.dispatch(change('newEntity', 'twoFADashboard', true));
        break;
      case "yesNoConsultationRequest":
        if (!input.value) {
          this.props.showNoCallFabricatorSelection(this.props.formValues.noCallFabricatorId, this.handleSetNoCallFabricator);
        }
        break;
      case "enableFingerSignature":
        if (!input.value) {
        }
        break;
      case "showPricing":
        input.value && this.props.dispatch(change('newEntity', 'checkOut', false));
        break;
      case "enableCookiePopup":
        input.value && this.props.dispatch(change('newEntity', 'enableCookiePopup', false));
        break;
      case "enableSqFt":
        input.value && this.props.dispatch(change('newEntity', 'enableSqFt', false));
        break;
      case "enableSqFtKitchen":
        input.value && this.props.dispatch(change('newEntity', 'enableSqFtKitchen', false));
        break;
      case "enableQuoteKitchen":
        !input.value && this.props.dispatch(change('newEntity', 'leadCaptureKitchen', true));
        !input.value && this.props.dispatch(change('newEntity', 'twoFAKitchen', true));
        break;
      case "showTutorialVideo":
        input.value && this.props.dispatch(change('newEntity', 'showTutorialVideo', false));
        break;
      case "enableQuoteDashboardKitchen":
        !input.value && this.props.dispatch(change('newEntity', 'leadCaptureDashboardKitchen', true));
        !input.value && this.props.dispatch(change('newEntity', 'twoFADashboardKitchen', true));
        break;
      case "yesNoConsultationRequestKitchen":
        if (!input.value) {
          this.props.showNoCallFabricatorSelection(this.props.formValues.noCallFabricatorIdKitchen, this.handleSetNoCallFabricator, 'kitchen');
        }
        break;
      case "enableFingerSignatureKitchen":
        if (!input.value) {
        }
        break;
      case "showPricingKitchen":
        input.value && this.props.dispatch(change('newEntity', 'checkOutKitchen', false));
        break;
      case "enableCookiePopupKitchen":
        input.value && this.props.dispatch(change('newEntity', 'enableCookiePopupKitchen', false));
        break;
    }
    this.props.dispatch(change('newEntity', input.name, !input.value));
  };

  // this will be called when the modal for FingerSigning will be closed on OK button
  handleSetFabricatorMasterDocument = ({documentFullUrl}) => {
    this.props.formValues.fingerSignatureTermsAcceptedAt = new Date();
    this.props.formValues.fingerSignatureMasterDocumentFullUrl = documentFullUrl;
  }

  getFabricatorImageStyles = () => ({
    'width': 'auto',
    'maxHeight': '100%',
    'maxWidth': '100%',
    'display': this.props.initialValues.companyLogoURL ? 'inline-block' : 'none'
  });

  handleUploadFieldChange = (e) => {
    let files = null;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }

    if (!files || !files.length) {
      console.log("No Files selected");
      return;
    }

    const file = files[0];

    if (file.size > 12 * 1024 * 1024) {
      this.props.errorBox_Show({
        title: 'Error',
        text: 'File too large.',
        rightButtonText: 'OK',
        isRightButtonVisible: true
      });
      return;
    }

    if (!isImageFile(file.name)) {
      this.props.errorBox_Show({
        title: 'Error',
        text: 'File is not an image.',
        rightButtonText: 'OK',
        isRightButtonVisible: true
      });
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      var node = ReactDOM.findDOMNode(this.refs.iconHolder);
      node.src = reader.result;
      node.style.display = 'inline-block';

      this.props.dispatch(change('newEntity', 'CompanyLogo', reader.result));
      // ReactDOM.findDOMNode(this.refs.iconHolder).style.backgroundImage = bkgImage(reader.result);
    };
    reader.readAsDataURL(file);

    // this.props.setActiveFilterGroupIcon(file);
  };

  currentEntityForAR = () => {
    if (this.state.isEmployee)
      return this.props.AR.employee(this.props.initialValues);

    if (this.state.isCustomer)
      return this.props.AR.customer(this.props.initialValues);

    if (this.state.isFabricator)
      return this.props.AR.fabricator(this.props.initialValues);
  }

  showESignatureOverlay = (key) => {
    let paymentType = this.state[key + "PaymentType"];
    let sub = _.find(this.props.subscriptions, sub => sub.id === paymentType.id);
    if (sub && sub.adminOnly) {
      this.setState({fabricatorNeedToSignAgreement: false});
    } else {
      document.getElementsByClassName('new-account-content')[0].classList.add('noscroll');
      this.setState({showingESignFor: key});
      this.props.showESignatureOverlayFn(true);
    }
  }

  handleJotFormSubmitted = () => {
    document.getElementsByClassName('new-account-content')[0].classList.remove('noscroll');
    this.setState({fabricatorNeedToSignAgreement: false});
    this.props.showESignatureOverlayFn(false);
  }

  saveCC = (e) => {
    misc.ignoreDefault(e);

    let errors = misc.validateCCInfo({
      name: this.state.ccName,
      number: this.state.ccNum,
      expYear: this.state.ccExpYear,
      expMonth: this.state.ccExpMonth,
      cvv: this.state.ccCVV
    });
    if (!this.state.ccTermsApproved) {
      errors.push("Please review and approve the terms of use for this credit card number.");
    }
    if (errors.length > 0) {
      this.props.messageBoxEx_Show(true, 'error', 'Invalid/Missing credit card information', errors.join('<br />'));
      return false;
    }
    this.props.dispatch(change('newEntity', 'billingAddress.name', this.state.ccName));
    if (this.state.onCCSave) {
      this.state.onCCSave();
      this.setState({onCCSave: null});
    }
    this.setState({saveCC: true, showCreditCardOverlay: false});
  }

  saveDocuSign = e => {
    misc.ignoreDefault(e);
    let errors = [];
    if (!this.state.ds_isProduction) {
      if (_.trim(this.state.ds_sandBoxUserId).length === 0) {
        errors.push("Sandbox User Id is required when using Sandbox mode.");
      }
      if (_.trim(this.state.ds_sandBoxAuthToken).length === 0) {
        errors.push("Sandbox Access Token is required when using Sandbox mode.");
      }
    } else {
      if (_.trim(this.state.ds_prodClientId).length === 0) {
        errors.push("Production Client Id is required when using Production mode.");
      }
      if (_.trim(this.state.ds_prodUserId).length === 0) {
        errors.push("Production User Id is required when using Production mode.");
      }
      if (_.trim(this.state.ds_prodPrivateKey).length === 0) {
        errors.push("Production Private Key is required when using Production mode.");
      }
    }
    if (_.isEmpty(_.trim(this.state.ds_checkOutContractId))) {
      errors.push('Checkout Template Id is required.');
    }

    if (errors.length > 0) {
      this.props.messageBoxEx_Show(true, 'error', 'Invalid/Missing DocuSign Information', errors.join('<br />'));
    } else {
      const docuSignObj = {
        sandBoxClientId: this.state.ds_sandBoxUserId,
        accessToken: this.state.ds_sandBoxAuthToken,
        isSandBox: !this.state.ds_isProduction,
        clientId: this.state.ds_prodClientId,
        impersonateUserGuid: this.state.ds_prodUserId,
        privateKey: this.state.ds_prodPrivateKey,
        isEnabled: this.props.formValues.enableDocuSign,
        docuSignTemplates: {
          checkOutContract: {
            id: this.state.ds_checkOutContractId
          }
        }
      };

      this.setState({showDocuSignOverlay: false, docuSignObj: {...docuSignObj}});
    }
  }

  getProgramTypePriority = type => {
    switch (type) {
      case 'free':
        return 0;
      case 'pay-per-lead':
      case 'kv-only':
      case 'bv-only':
      case 'kv-bv-only':
        return 1;
      case 'basics':
        return 2;
      case 'enterprise':
        return 3;
      default:
        return -1;
    }
  }

  getProgramTypes = (initialProgramType, key) => {
    let programTypes = [];
    const initialProgramTypePriority = this.getProgramTypePriority(initialProgramType);
    for (let i = 0; i < this.props.subscriptions.length; i++) {
      let sub = this.props.subscriptions[i];
      if (sub.type === "kv-only" && key !== 'kitchen')
        continue;
      if (sub.type === 'bv-only' && key !== 'bathroom')
        continue;
      if (programTypes.indexOf(sub.type) === -1) {
        const priority = this.getProgramTypePriority(sub.type);
        if (this.state.isNew || priority >= initialProgramTypePriority) {
          programTypes.push(sub.type);
        }
      }
    }
    programTypes.sort();
    return programTypes;
  }

  getPaymentTypes = (key, programType = this.state[key + "ProgramType"], props = this.props, include = 0) => {
    let paymentTypes = [];
    for (let i = 0; i < props.subscriptions.length; i++) {
      let sub = props.subscriptions[i];
      if (sub.type === programType) {
        let text = sub.period;
        if (sub.adminOnly && ((!this.state[key + "PaymentType"] || this.state[key + "PaymentType"].id !== sub.id) && !this.props.AR.isSiteAdmin(true)) && (include == 0 || include != sub.id))
          continue;
        if (sub.adminOnly && sub.price === 0) {
          if (sub.period === "monthly") {
            text = "(SA Only) Free Monthly";
          } else {
            text = "(SA Only) Free Pre-Paid";
          }
        } else {
          if (sub.contractPeriod === "annually" && sub.period === "monthly") {
            text = "Annually, billed monthly";
          } else if (sub.contractPeriod === "annually" && sub.period === "annually") {
            text = "Annually, pre-paid";
          }
        }
        paymentTypes.push({id: sub.id, period: sub.period, contractPeriod: sub.contractPeriod, text});
      }
    }
    return paymentTypes;
  }

  capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  updateProgramType = (key, value) => {
    let paymentTypes = this.getPaymentTypes(key, value);
    let paymentType = paymentTypes[0];
    let sub = _.find(this.props.subscriptions, s => s.id === paymentType.id);
    let period = sub.period;
    let price = "$" + sub.price.toFixed(2);
    switch (key) {
      case "kitchen":
        this.props.dispatch(change('newEntity', 'enableKV', true));
        break;
      case "bathroom":
        this.props.dispatch(change('newEntity', 'enableBV', true));
        break;
    }
    switch (period) {
      case 'annually':
        period = 'year';
        break;
      case 'monthly':
        period = 'month';
        break;
    }
    let msg = null;
    switch (sub.type) {
      case "free":
        msg = "You are subscribing to the Free Trial account.  Are you sure you wish to proceed?";
        break;
      case "pay-per-lead":
        msg = `You are changing to the ${this.capitalizeFirstLetter(sub.type)} program.  You will be charged ${price} per ${period} with this change.  Are you sure you wish to proceed?`;
        break;
    }
    if (msg != null) {
      this.props.messageBoxEx_Show(true, "system", "Confirm Program Change", msg,
        [{
          text: 'Yes',
          onClick: () => {
            this.props.messageBoxEx_Show(); //reset to default props (not visible by default)
            this.setState({
              programTypeKey: key,
              [key + "ProgramType"]: value,
              [key + "PaymentType"]: "Select",
              [key + 'PaymentAmount']: sub.price
            }, () => {
              if (paymentTypes.length === 1) {
                this.setState({[key + "PaymentType"]: paymentType}, () => {
                  if ((!this.props.paymentProfile || !this.props.paymentProfile.customerProfileId) && !this.state.saveCC && sub.price > 0) {
                    this.setState({
                      showCreditCardOverlay: true, onCCSave: () => {
                        this.setState({
                            programTypeKey: key,
                            [key + "ProgramType"]: sub.type,
                            [key + "PaymentType"]: paymentType,
                            [key + 'PaymentAmount']: sub.price
                          },
                          () => {
                            this.props.setSubscriptionIdFn(key, sub);
                            this.showESignatureOverlay(key);
                          });
                      }
                    });
                  } else {
                    this.props.setSubscriptionIdFn(key, sub);
                    this.showESignatureOverlay(key);
                  }
                });

                if (key === "bathroom")
                  this.setBathroomDefaults(sub);
              }
            });
          }
        }, {
          text: 'Cancel',
          onClick: () => this.props.messageBoxEx_Show()
        }]
      );
    } else {
      this.setState({
        programTypeKey: key,
        [key + "ProgramType"]: value,
        [key + "PaymentType"]: "Select",
        [key + 'PaymentAmount']: sub.price
      });
    }
  }

  setBathroomDefaults = (sub) => {
    switch (sub.type) { //preparing for the future of needing different selections based on subscription
      default:
        if (this.state.isNew) {
          this.props.dispatch(change('newEntity', 'enableSharing', true));
          this.props.dispatch(change('newEntity', 'wizardClients', true));
          this.props.dispatch(change('newEntity', 'wizardConsumers', true));
          this.props.dispatch(change('newEntity', 'leadCapture', true));
          this.props.dispatch(change('newEntity', 'twoFA', true));
          this.props.dispatch(change('newEntity', 'visualizerOnly', true));
          this.props.dispatch(change('newEntity', 'enableSharingKitchen', true));
          this.props.dispatch(change('newEntity', 'wizardClientsKitchen', true));
          this.props.dispatch(change('newEntity', 'wizardConsumersKitchen', true));
          this.props.dispatch(change('newEntity', 'leadCaptureKitchen', true));
          this.props.dispatch(change('newEntity', 'twoFAKitchen', true));
          this.props.dispatch(change('newEntity', 'visualizerOnlyKitchen', true));
        }
        break;
    }
  }

  updatePaymentType = (key, paymentType) => {
    //console.log(111, key, paymentType);
    let sub = _.find(this.props.subscriptions, s => s.id === paymentType.id);
    let price = "$" + sub.price.toFixed(2);
    let period = sub.period;
    let msg = `You are changing to the ${this.capitalizeFirstLetter(sub.type)} program.  You will be charged ${price} per ${period} with this change.  Are you sure you wish to proceed?`;
    this.props.messageBoxEx_Show(true, "system", "Confirm Program Change", msg,
      [{
        text: 'Yes',
        onClick: () => {
          this.props.messageBoxEx_Show(); //reset to default props (not visible by default)
          this.setState({
            programTypeKey: key,
            [key + "PaymentType"]: "Select",
            [key + 'PaymentAmount']: sub.price
          }, () => {
            if (key === "bathroom") {
              this.setBathroomDefaults(sub);
            }
            if ((!this.props.paymentProfile || !this.props.paymentProfile.customerProfileId) && !this.state.saveCC && sub.price > 0) {
              this.setState({
                showCreditCardOverlay: true, onCCSave: () => {
                  this.setState({
                      programTypeKey: key,
                      [key + "ProgramType"]: sub.type,
                      [key + "PaymentType"]: paymentType,
                      [key + 'PaymentAmount']: sub.price
                    },
                    () => {
                      this.props.setSubscriptionIdFn(key, sub);
                      this.showESignatureOverlay(key);
                    });
                }
              });
            } else {
              this.setState({
                  programTypeKey: key,
                  [key + "ProgramType"]: sub.type,
                  [key + "PaymentType"]: paymentType,
                  [key + 'PaymentAmount']: sub.price
                },
                () => {
                  this.props.setSubscriptionIdFn(key, sub);
                  this.showESignatureOverlay(key);
                });
            }
          });
        }
      }, {
        text: 'Cancel',
        onClick: () => this.props.messageBoxEx_Show()
      }]
    );
  }

  updateCurrency = (activeCurrency, type) => {
    if (type === 'kitchen') {
      this.setState({
        activeCurrencyKitchen: activeCurrency
      });
      this.props.dispatch(change('newEntity', 'currencyKitchen', activeCurrency));
    } else {
      this.setState({
        activeCurrency
      });
      this.props.dispatch(change('newEntity', 'currency', activeCurrency));
    }
  }

  updateWebHookDataType = activeWebHookDataType => {
    this.setState({
      activeWebHookDataType
    });
    this.props.dispatch(change('newEntity', 'webHookProperties.dataType', activeWebHookDataType));
  }

  copyHomeAdvisorApiEndpointUrl = () => {
    const ta = document.createElement('textarea');
    ta.value = this.props.homeAdvisorApiEndpointUrl;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
    this.setState({showCopied: true}, () => window.setTimeout(() => this.setState({showCopied: false}), 1500));
  }

  showPaymentGateways = () => {
    this.props.loadPaymentGateways(this.state.entityId)
      .then((res) => {
          this.setState({
            showPaymentGateways: true,
            paymentGateway_MxMerchant_MerchantId: (res && res.mxMerchant && res.mxMerchant.merchantId) || '',
            paymentGateway_MxMerchant_ApiKey: (res && res.mxMerchant && res.mxMerchant.apiKey) || '',
            paymentGateway_MxMerchant_ApiSecret: (res && res.mxMerchant && res.mxMerchant.apiSecret) || '',
            paymentGateway_MxMerchant_NachaId: (res && res.mxMerchant && res.mxMerchant.nachaId) || '',
            paymentGateway_MxMerchant_TestMode: (res && res.mxMerchant && res.mxMerchant.testMode) || '',
            paymentGateway_AuthNet_ApiLogin: (res && res.authorizeNet && res.authorizeNet.apiLoginId) || '',
            paymentGateway_AuthNet_TransactionKey: (res && res.authorizeNet && res.authorizeNet.transactionKey) || '',
            paymentGateway_AuthNet_TestMode: (res && res.authorizeNet && res.authorizeNet.testMode) || false,
            paymentGateway_AuthNet_customEndpointUrl: (res && res.authorizeNet && res.authorizeNet.customEndpointUrl) || ''
          })
        }
      );
  }

  savePaymentGateways = () => {
    let paymentGateways = {
      fabricatorId: this.state.entityId,
      authorizeNet: {
        apiLoginId: this.state.paymentGateway_AuthNet_ApiLogin,
        transactionKey: this.state.paymentGateway_AuthNet_TransactionKey,
        testMode: this.state.paymentGateway_AuthNet_TestMode,
        customEndpointUrl: this.state.paymentGateway_AuthNet_CustomEndpointUrl
      },
      mxMerchant: {
        merchantId: this.state.paymentGateway_MxMerchant_MerchantId,
        apiKey: this.state.paymentGateway_MxMerchant_ApiKey,
        apiSecret: this.state.paymentGateway_MxMerchant_ApiSecret,
        nachaId: this.state.paymentGateway_MxMerchant_NachaId,
        testMode: this.state.paymentGateway_MxMerchant_TestMode,
      }
    };
    this.props.savePaymentGateways(paymentGateways).then((res) => res && this.setState({
      showPaymentGateways: false
    }));
  }

  copyHomeAdvisorApiEndpointUrl = () => {
    const ta = document.createElement('textarea');
    ta.value = this.props.homeAdvisorApiEndpointUrl;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
    this.setState({showCopied: true}, () => window.setTimeout(() => this.setState({showCopied: false}), 1500));
  }

  saveDisclaimer = () => {
    this.props.dispatch(change('newEntity', 'disclaimer', this.state.editDepositDisclaimer));
    this.setState({showDepositDisclaimer: false})
  }

  render = template;
}

AddNewEntity.propTypes = {
  getCustomerInfo: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  showESignatureOverlay: PropTypes.bool.isRequired,
  showESignatureOverlayFn: PropTypes.func.isRequired,
  setSubscriptionIdFn: PropTypes.func.isRequired,
  showAssignEntityPopup: PropTypes.func.isRequired,
  masterProfile: PropTypes.object.isRequired
};

const connector = connect(mapStateToProps, mapDispatchToProps);

const AddNewEntityForm = reduxForm({form: 'newEntity'})(AddNewEntity);
const AddNewEntityFooterForm = reduxForm({form: 'newEntity'})(AddNewEntityFooter);

export const AddNewEntityLayoutComponents = modifyPageLayoutComponents({
  pageHeader: connector(AddNewEntityHeader),
  content: injectIntl(connector(AddNewEntityForm)),
  pageFooter: connector(AddNewEntityFooterForm)
});

